import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../Layout/Navbar';
import PublicNavbar from '../Layout/PublicNavbar';
import Footer from '../Layout/Footer';
import { useAuth } from '../../contexts/AuthContext';
import SEO from '../Common/SEO';
import './NotFound.css';

function NotFound() {
  const { isAuthenticated } = useAuth();

  return (
    <div className="page-wrapper">
      <SEO
        title="Page Not Found"
        description="The page you're looking for doesn't exist. Return to Options Tracker to continue tracking your trades."
      />
      {isAuthenticated ? <Navbar /> : <PublicNavbar />}
      <div className="container not-found-page">
        <div className="not-found-content">
          <div className="not-found-icon">404</div>
          <h1>Page Not Found</h1>
          <p>
            The page you're looking for doesn't exist or has been moved.
          </p>
          <Link to="/" className="btn btn-primary">
            Go to Home
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default NotFound;
